<div [formGroup]="form">
  <div style="width: 400px">
    <div class="control required">
      <label>Navn</label>
      <input pInputText formControlName="navn" />
      @if (form.controls['navn'].errors &&
      form.controls['navn'].touched) {
        <p class="error">Feltet skal udfyldes</p>
      }
    </div>
    <div class="control">
      <label>Bestyrelsespost</label>
      <input pInputText formControlName="bestyrelsesTitel" />
    </div>
    <div class="control">
      <label>Titel</label>
      <input pInputText formControlName="stilling" />
    </div>
    <div class="control">
      <label>Rækkefølge</label>
      <input pInputText formControlName="raekkeFoelge" />
    </div>

    <div class="flex gap-4">
      <p-button
        label="Gem ændringer"
        icon="pi pi-save"
        (click)="onClickSave()"
        [disabled]="!form.valid"
      />
      <p-button
        label="Slet bestyrelsesmedlem"
        icon="pi pi-trash"
        severity="danger"
        outlined
        (click)="onClickDelete($event)"
      />
    </div>
  </div>
</div>
<p-confirmDialog />
